/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { makeAutoObservable } from "mobx"

import type { ApkDetail } from "./apk-detail-types"

/**
 * Holds the detail for one APK.
 *
 * Each `ApkDetailViewModel` owns its store, so detail for different APKs cannot
 * overwrite each other when requests finish out of order.
 */
export class ApkDetailStore {
    // `null` until the first successful load.
    detail: ApkDetail | null = null

    constructor() {
        makeAutoObservable(this)
    }

    setDetail(detail: ApkDetail): void {
        this.detail = detail
    }
}
